// =============================================
// GALERIA — 5 slots fixos, transição suave via slideTo + snap invisível
// =============================================
(function initGaleriaSobre() {
    const root = document.querySelector('#about .galeria .slide-wrapper');
    const el   = document.querySelector('#about .slide-galeria');
    if (!root || !el) return;

    const prevBtn = root.querySelector('.arrow-prev-galeria');
    const nextBtn = root.querySelector('.arrow-next-galeria');

    const allSlideEls = Array.from(el.querySelectorAll('.swiper-slide'));
    const N = allSlideEls.length;
    if (N < 1) return;

    const data = allSlideEls.map(s => ({
        src:  s.querySelector('.img-galeria img')?.getAttribute('src')  || '',
        alt:  s.querySelector('.img-galeria img')?.getAttribute('alt')  || '',
        text: s.querySelector('.conteudo-slide p')?.innerHTML           || '',
    }));

    // Mantém apenas 5 slots no DOM
    const SLOTS = 5;
    allSlideEls.slice(SLOTS).forEach(s => s.remove());
    const slots      = Array.from(el.querySelectorAll('.swiper-slide'));
    const slotsCount = slots.length;
    const centerSlot = Math.floor(slotsCount / 2); // índice 2

    let centerData   = 0;
    let isAnimating  = false;

    function mod(n, m) { return ((n % m) + m) % m; }

    function swapContent() {
        slots.forEach((slot, i) => {
            const di  = mod(centerData + (i - centerSlot), N);
            const d   = data[di];
            const img = slot.querySelector('.img-galeria img');
            const p   = slot.querySelector('.conteudo-slide p');
            if (img) { img.src = d.src; img.alt = d.alt; }
            if (p)   p.innerHTML = d.text;
        });
    }

    const desktopSPV = slotsCount > 1 ? slotsCount - 0.01 : slotsCount;
    const swiper = new Swiper(el, {
        effect: 'coverflow',
        grabCursor: false,
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        allowTouchMove: false,
        speed: 520,
        initialSlide: centerSlot,
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 4,
            slideShadows: false,
        },
        keyboard: false,
        breakpoints: {
            560: { slidesPerView: Math.min(slotsCount, 2.5) },
            768: { slidesPerView: Math.min(slotsCount, 3.5) },
            992: { slidesPerView: desktopSPV },
        },
    });

    // Navega: anima para o slot adjacente → atualiza centro → snapa de volta
    function go(delta) {
        if (isAnimating) return;
        isAnimating = true;

        swiper.slideTo(centerSlot + delta, 520);

        swiper.once('transitionEnd', () => {
            centerData = mod(centerData + delta, N);

            // Atualiza o slot central com o novo conteúdo (coincide com o que acabou de animar)
            const d   = data[centerData];
            const img = slots[centerSlot].querySelector('.img-galeria img');
            const p   = slots[centerSlot].querySelector('.conteudo-slide p');
            if (img) { img.src = d.src; img.alt = d.alt; }
            if (p)   p.innerHTML = d.text;

            // Desativa transitions CSS antes do snap para suprimir o flash causado pela
            // mudança de swiper-slide-active (que dispararia transform e opacity)
            const items    = el.querySelectorAll('.item-galeria');
            const contents = el.querySelectorAll('.conteudo-slide');
            items.forEach(item    => item.style.transition    = 'none');
            contents.forEach(cnt  => cnt.style.transition     = 'none');

            // Snapa de volta ao centro sem animação — invisível pois o conteúdo é igual
            swiper.slideTo(centerSlot, 0);

            // Atualiza os slots laterais e restaura transitions após dois frames (garante pintura)
            requestAnimationFrame(() => {
                swapContent();
                requestAnimationFrame(() => {
                    items.forEach(item    => item.style.transition    = '');
                    contents.forEach(cnt  => cnt.style.transition     = '');
                    isAnimating = false;
                });
            });
        });
    }

    prevBtn.addEventListener('click', () => go(-1));
    nextBtn.addEventListener('click', () => go(1));

    document.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  go(-1);
        if (e.key === 'ArrowRight') go(1);
    });

    swapContent();
})();

// =============================================
// LINHA DO TEMPO — roleta animada + setas manuais
// =============================================
const INITIAL_SLIDE = 2;

const swiperInfo = new Swiper('.slide-info-tempo', {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    slidesPerView: 1,
    allowTouchMove: false,
    initialSlide: INITIAL_SLIDE,
    speed: 500,
});

const swiperLinhaTempo = new Swiper('.slide-linha-tempo', {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    slidesPerView: 1,
    allowTouchMove: false,
    initialSlide: INITIAL_SLIDE,
    speed: 500,
});

swiperLinhaTempo.controller.control = swiperInfo;
swiperInfo.controller.control = swiperLinhaTempo;

const anosEls   = document.querySelectorAll('.linha-tempo .anos .ano');
const prevArrow = document.querySelector('.linha-tempo .prevnext-arrow');
const nextArrow = document.querySelector('.linha-tempo .next-arrow');
const TOTAL     = anosEls.length;

// Posições no arco desktop: [top%, leftPx]
const ARC = [
    { top: 25,   left: 58 },
    { top: 37.5, left: 14 },
    { top: 50,   left: 0  },  // centro / ativo
    { top: 62.5, left: 14 },
    { top: 75,   left: 58 },
];

// Retorna índice de posição no arco (0-4) para o item i dado o activeIndex
function getPosIdx(i, activeIdx) {
    const rel = ((i - activeIdx) % TOTAL + TOTAL) % TOTAL;
    if (rel === 0)          return 2;
    if (rel === 1)          return 3;
    if (rel === 2)          return 4;
    if (rel === TOTAL - 1)  return 1;
    if (rel === TOTAL - 2)  return 0;
    return -1;
}

function setArrowsState(idx) {
    const mobile = window.innerWidth < 992;
    // No mobile a ordem visual é invertida (anos recentes à esquerda):
    // prevArrow (←) avança para anos mais novos → desativa no último (mais novo)
    // nextArrow (→) recua para anos mais velhos → desativa no primeiro (mais velho)
    prevArrow?.classList.toggle('swiper-button-disabled', mobile ? idx === TOTAL - 1 : idx === 0);
    nextArrow?.classList.toggle('swiper-button-disabled', mobile ? idx === 0         : idx === TOTAL - 1);
}

let prevActiveIdx = INITIAL_SLIDE;

function atualizarAno(newIdx, fromIdx) {
    const desktop = window.innerWidth >= 992;

    anosEls.forEach((el, i) => {
        const newPos = getPosIdx(i, newIdx);
        const oldPos = fromIdx != null ? getPosIdx(i, fromIdx) : newPos;

        el.classList.toggle('active', newPos === 2);

        if (!desktop) return;

        // Item faz "salto" (volta pelo outro lado da roleta) — dissolve em vez de cruzar
        const jumps = fromIdx != null && Math.abs(newPos - oldPos) >= 3;

        if (jumps) {
            el.style.transition = 'opacity 0.18s ease';
            el.style.opacity    = '0';
            setTimeout(() => {
                const p = ARC[newPos];
                el.style.transition = 'none';
                el.style.top  = p.top  + '%';
                el.style.left = p.left + 'px';
                requestAnimationFrame(() => {
                    el.style.transition = '';
                    el.style.opacity    = '';
                });
            }, 200);
        } else if (newPos !== -1) {
            const p = ARC[newPos];
            el.style.top  = p.top  + '%';
            el.style.left = p.left + 'px';
        }
    });

    setArrowsState(newIdx);
}

// Inicializa posições sem animação
atualizarAno(INITIAL_SLIDE, null);

// Sincroniza roleta quando o Swiper muda
swiperLinhaTempo.on('slideChange', function () {
    atualizarAno(this.activeIndex, prevActiveIdx);
    prevActiveIdx = this.activeIndex;
});

// Setas manuais (sem depender do navigation nativo do Swiper)
// No mobile o grid tem anos novos à ESQUERDA, então ← = mais novo (slideNext) e → = mais velho (slidePrev)
prevArrow?.addEventListener('click', () => {
    const mobile = window.innerWidth < 992;
    if (mobile) {
        if (swiperLinhaTempo.activeIndex < swiperLinhaTempo.slides.length - 1) swiperLinhaTempo.slideNext();
    } else {
        if (swiperLinhaTempo.activeIndex > 0) swiperLinhaTempo.slidePrev();
    }
});
nextArrow?.addEventListener('click', () => {
    const mobile = window.innerWidth < 992;
    if (mobile) {
        if (swiperLinhaTempo.activeIndex > 0) swiperLinhaTempo.slidePrev();
    } else {
        if (swiperLinhaTempo.activeIndex < swiperLinhaTempo.slides.length - 1) swiperLinhaTempo.slideNext();
    }
});

// Clique nos anos do arco
anosEls.forEach((el, i) => {
    el.addEventListener('click', () => {
        const from = swiperLinhaTempo.activeIndex;
        swiperLinhaTempo.slideTo(i);
        atualizarAno(i, from);
        prevActiveIdx = i;
    });
});
